import React from 'react';
import { ServiceTitle } from '../modules/ServiceTitle';

class NetworkOutage extends React.Component {
    render() {
        if(this.props.isOutagePresents) {
            return (
                <React.Fragment>
                    <section className="main large-mw-none" role="region">
                        <div className="row large-padding-vert-zero">
                            <div className="tiny-12 small-12 medium-12 large-12 columns text-left">
                                <h1 className="h2 margin-bottom-micro">
                                    Outages may be interrupting your services.</h1>
                            </div>
                        </div>
                    </section>
    
                    <section className="main bg-black large-mw-none padding-horiz-medium" role="region">
                        <div className="row text-white">
                        <Outage TimeConversionCallBack={this.props.ConvertTime} data={this.props.Outage} staticData={this.props.OutageStaticData}></Outage>
                        </div> 
                    </section>
    
                    <section className="main large-mw-none border-bottom padding-horiz-large notification_section" role="region">
                        <Notification data={this.props.Outage} staticData={this.props.NotificationItems} KeyPressValidaiton={this.props.KeyDownValidation} ValidationCallBack={this.props.Validation} SubmitCallBack={this.props.Submit}></Notification>
                    </section>
                </React.Fragment>
            )
        } else {
            return(
                <React.Fragment>
                    <ServiceTitle Title="We are not detecting outages in your area."/>
                    {/* Status banner section */}
                    <section className="main bg-black large-mw-none" role="region">
                        <div className="row text-white">
                            <div className="column tiny-12">
                                <div className="all-services-header">
                                    <div className="all-services-content">
                                        <span className="vzicon icon-check-alt bg-white text-brand-2  large circled no_outage"></span></div>
                                    <div className="all-services-content vert-top padding-left-small padding-top-tiny">
                                        <div className="bold outage-alert-header padding-bottom-small">
                                            All good!</div>
                                        <div className="padding-bottom-tiny">You should be able to use all your Fios services as expected.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
        
                    <section className="main large-mw-none border-bottom padding-horiz-medium" role="region">
                        <div className="row">
                            <div className="tiny-12 small-12 medium-12 large-12 columns padding-bottom-small">
                                <div className="outage-alert-header bold">
                                    Are you still having trouble with your service?</div>
                                <div>
                                    If you are only experiencing issues with your Verizon services, please see below for more information on tips to resolve. If you are looking to check the status of an existing repair request or are looking to update your request please visit <a href="/ForYourHome/VzRepair/VzIHA/Servicecad.aspx?ihaweb=Web_TroubleTicket" data-track="CheckStatus" tabIndex="0">verizon.com/CheckStatus</a>.</div>
                            </div>
                            <div className="tiny-12 medium-6 columns medium-padding-right-small tiny-padding-right-tiny">
                                <div className="outage-border padding-top-tiny">
                                    <a className="button outage-cta-btn cta-text padding-bottom-small" href="https://www.verizon.com/ForYourHome/VZRepair/vziha/Servicecad.aspx?ihaweb=FIX_ASO" role="button" data-track="All service are out" tabIndex="0">All service are out</a></div>
                            </div>
                            <div className="tiny-12 medium-6 columns medium-padding-right-small tiny-padding-right-zero">
                                <div className="outage-border outage-border-none medium-padding-top-tiny tiny-padding-top-zero">
                                    <a className="button outage-cta-btn cta-text padding-bottom-small" href="#tips" role="button" tabIndex="0" data-track="I have another issue with my service ">I have another issue with my service </a></div>
                            </div>
                        </div>
                    </section>
            </React.Fragment>
            )
        }
        
    }
} 

export default NetworkOutage;


function Outage(OutageData) {
    if(OutageData.data.length > 1) {
        return (
                OutageData.data.map((item, index) => {
                    return <div key={index} className="column tiny-12 double-outage medium-6  medium-border-right tiny-border-bottom tiny-text-center medium-text-left relative medium-padding-bottom-zero tiny-padding-bottom-small">
                        <div className="outage-alert-icon">
                            <span className="tv-outage-icon"> <img alt="outage" src={"https://www.verizon.com" +item.insights.icondesc}/> </span></div>
                        <div className="bold outage-alert-header padding-bottom-tiny">
                            {item.insights.headertext}</div>
                        <div className="outage-alert-msg"> {item.insights.verbiage_outage} </div>
                        <div className="bold text-xlarge padding-bottom-tiny">
                            &nbsp;</div>
                        <div className="bold outage-alert-subtext">
                            Estimated Restoration time</div>
                        <div className="bold outage-alert-subtext time_value">
                            {OutageData.TimeConversionCallBack(item.insights.outagerestorationtime)}</div>
                    </div>
                })
            )
    }  else {
        return (
            <React.Fragment>
                <div className="column medium-6  medium-border-right ">
                    <div className="all-services-header">
                        <div className="all-services-content tiny-padding-bottom-micro medium-padding-bottom-zero">
                            <span className="vzicon icon-alert bg-white text-brand-1 outage-icon circled single-outage"></span></div>
                        <div className="all-services-content vert-top medium-padding-left-tiny tiny-padding-left-zero">
                            <div className="bold outage-alert-header medium-padding-bottom-small tiny-padding-bottom-tiny">
                                {OutageData.data[0].insights.headertext}</div>
                            <div className="bold medium-padding-bottom-small tiny-padding-bottom-tiny outage-alert-subheader">
                                Our tech support team is working on it.</div>
                            <div className="medium-padding-bottom-tiny tiny-padding-bottom-zero">
                            {OutageData.data[0].insights.verbiage_outage} </div>
                        </div>
                    </div>
                </div>
                <div className="column medium-6 medium-padding-top-zero tiny-padding-top-small medium-padding-left-small tiny-padding-left-micro tiny-text-center medium-text-left">
                    <div className="bold outage-alert-header"> {OutageData.staticData[0].servicedate}</div>
                    <div className="bold outage-alert-header medium-padding-bottom-small tiny-padding-bottom-zero time_value">
                    {OutageData.TimeConversionCallBack(OutageData.data[0].insights.outagerestorationtime)}</div>
                    <div className="bold padding-bottom-small">
                        &nbsp;</div>
                    <div className="padding-bottom-tiny">
                        Outage ticket <span className="bold">{OutageData.data[0].insights.outageticketnum}</span></div>
                </div>
    </React.Fragment>
        )
    }
}

function Notification(NotificationData) {
    if(NotificationData.data.length > 1) {
        return (
            <React.Fragment>
                <div className="row large-padding-vert-zero" id="div1">
                    <div className="tiny-12 small-12 medium-12 large-12 columns padding-bottom-small">
                        <div className="outage-alert-header bold">
                            {NotificationData.staticData[0].title}</div>
                        <div>
                            {NotificationData.staticData[0].description}</div>
                    </div>
                    <div className="tiny-12 small-12 medium-12 large-12 columns">
                        <div className="inline-block large-p-25 medium-p-35 small-p-90 tiny-p-90">
                            <label className="outage-label">{NotificationData.staticData[0].mobilenumber}</label>
                            <input data-cs-mask aria-required="false" type="tel" maxLength="10"  onBlur={NotificationData.ValidationCallBack} className="outage-inp value" data-notification-inp="" id="userenteredMTN"/>
                            <p id="ErrTxt"></p>
                        </div>
                        <div className="padding-bottom-medium">
                            <div>
                                <input radioGroup="outageRadio" className="value" id="outage1" name="outageRadio" type="radio"/> <label aria-checked="false" aria-required="false" className="outage-radio" htmlFor="outage1" role="radio">{NotificationData.data[0].insights.headertext}</label></div>
                            <div>
                                <input radioGroup="outageRadio" className="value" id="outage2" name="outageRadio" type="radio"/> <label aria-checked="false" aria-required="false" className="outage-radio" htmlFor="outage2" role="radio">{NotificationData.data[1].insights.headertext}</label></div>
                        </div>
                        <div className="medium-text-left tiny-text-center">
                            <button className="rounded-button" onClick={NotificationData.SubmitCallBack} data-change-number="" data-notify-btn="" id="clickMe" data-track="Submit">Submit</button></div>
                    </div>
                </div>
                <div className="row large-padding-vert-zero hide" id="div2">
                    <div className="tiny-12 small-12 medium-12 large-12 columns padding-bottom-small">
                        <div className="outage-alert-header bold">
                            Get notified on updates.</div>
                        <div>
                            Enter a mobile number to receive updates when this is resolved.</div>
                    </div>
                    <div className="tiny-12 small-12 medium-12 large-12 columns">
                        <div className="outage-border padding-top-tiny">
                            <div className="text-large bold padding-top-tiny">
                                <div className="display-table">
                                    <div className="display-table-cell" id="testing">
                                        <span className="tick-icon icon-check small middle padding-right-tiny"></span></div>
                                    <div className="display-table-cell" id="thankyoucontent"> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </React.Fragment>
        )
    } else {
        return (
            <React.Fragment>
            <div className="row large-padding-vert-zero" id="div1">
                <div className="tiny-12 small-12 medium-12 large-12 columns padding-bottom-small">
                    <div className="outage-alert-header bold">
                    {NotificationData.staticData[0].title}</div>
                    <div>
                    {NotificationData.staticData[0].description}</div>
                </div>
                <div className="tiny-12 small-12 medium-12 large-12 columns notified_section">
                    <div className="inline-block large-p-25 medium-p-35 small-p-90 tiny-p-90">
                        <label className="outage-label">{NotificationData.staticData[0].mobilenumber}</label>
                        <input data-cs-mask aria-required="false" type="tel" maxLength="10" className="outage-inp value" onBlur={NotificationData.ValidationCallBack} data-notification-inp="" id="userenteredMTN"  />
                        <p id="ErrTxt"></p>
                    </div>
                    <div className="padding-bottom-medium">
                        <div className="medium-text-left tiny-text-center">
                            <button className="rounded-button" onClick={NotificationData.SubmitCallBack} data-change-number="" data-notify-btn="" id="clickMe" data-track="Submit">Submit</button></div>
                    </div>
                </div>
            </div>
</React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modules/NetworkOutage.js